import React, {useContext} from "react";
import i18n from "i18next";
import TrailerWithDamages from "./trailerWithDamages/trailerWithDamages";
import "./modifyTrailerDamages.scss";
import {RouteComponentProps, withRouter} from "react-router";
import DamagesTable from "./damagesTable/damagesTable";
import Form from "../../../../../../common/components/shared/form/form";
import {routingAddresses} from "../../../../../../helpers/routing";
import {storesContext} from "../../../../../../common/stores/stores";
import {observer} from "mobx-react";
import {SideType} from "../../../../../models/transport";

function ModifyTrailerDamages(props: RouteComponentProps): React.ReactElement {
    const params = props.match.params as {
        orderId: string,
        sideType: SideType
    };
    const orderId = params.orderId;
    const sideType = params.sideType;
    const tcrStore = useContext(storesContext).tcrStore;
    const backAddress = `${routingAddresses.order.modifyTcr}/${orderId}`;

    return (
        <div className="modify-trailer-damages content">
            <div className="header" data-testid="header">
                <span>({i18n.t(`transportation.order.tcr.sections.trailerCondition.sideTypeFirstLetter.${sideType}`)}) </span>
                <span>{i18n.t(`transportation.order.tcr.sections.trailerCondition.sideType.${sideType}`)}: </span>
                <span>{i18n.t("transportation.order.tcr.sections.trailerCondition.modifyTrailerDamages.header")}</span>
            </div>
            <Form
                renderContent={renderFormContent()}
                isSubmitButtonBlocked={false}
                submit={submit}
                backAddress={backAddress}
                hideCancelButton
                saveButtonText={i18n.t("transportation.order.tcr.sections.trailerCondition.modifyTrailerDamages.returnButtonText")}
            />
        </div>
    );

    function renderFormContent(): JSX.Element {
        return <div className="modify-trailer-damages-content">
            <TrailerWithDamages sideType={sideType}/>
            <DamagesTable sideType={sideType}/>
        </div>;
    }

    function submit(): void {
        tcrStore.copyDamagesToSelectedDamages();
        tcrStore.setIsAddDamages(true);
        props.history.push(backAddress);
    }
}

export default withRouter(observer(ModifyTrailerDamages));
